import './App.css';
import Footer from './loyout/Footer';
import Header from './loyout/Header';
import Main from './loyout/Main';

function App() {
  return (
    <>
      <Header />
      <Main />
      <Footer />
    </>
  );
}

export default App;
